import { Avatar } from '@jobseeker/lotus/components';
import {Grid, Typography} from '@mui/material';

export type RecruiterInfoProps = {
  name: string;
  organization?: string;
  profilePicture?: string;
  date?: string;
  designation?: string;
};

const formatDate = (dateString?: string) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(date);
};

const RecruiterInfo = ({
  name,
  organization,
  profilePicture,
  date,
  designation,
}: RecruiterInfoProps) => {
  const formattedDate = formatDate(date);
  return (
    <>
      <Grid container>
        <Grid
          item
          xs={2}
          sm={1}
          sx={{order: {xs: 2, sm: 1}}}
          pt={{xs: 1.9, sm: 0}}
          mr={{xs: 1.3, md: 1.3}}
          mb={{xs: 1.6, sm: 0}}
        >
          <Avatar
            imgUrl={profilePicture}
            sx={{
              borderRadius: '10px',
              width: '50px',
              height: '50px',
            }}
          ></Avatar>
        </Grid>
        <Grid
          item
          xs={8}
          sm={5}
          sx={{order: {xs: 3, sm: 2}}}
          pt={{xs: 1.9, sm: 0}}
          mb={{xs: 1.6, sm: 0}}
        >
          <Typography fontSize={14} lineHeight={1.3} fontWeight={200}>
            Sent by
          </Typography>
          <Typography fontSize={14} lineHeight={1.3} fontWeight={600}>
            {name}
          </Typography>
          <Typography fontSize={14} lineHeight={1.3} fontWeight={200}>
            {designation} at {organization}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={3}
          sx={{order: {xs: 1, sm: 3}}}
          borderBottom={{xs: 1, sm: 0}}
          borderColor={{xs: '#efefef'}}
        >
          <Typography fontSize={14} lineHeight={1.3} fontWeight={200}>
            Sent Date
          </Typography>
          <Typography
            fontSize={14}
            lineHeight={1.3}
            fontWeight={600}
            marginBottom={{xs: 0.7, md: 0}}
          >
            {formattedDate}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default RecruiterInfo;
